(function(register){
    if (document.readyState !== 'loading') {
        register();
    } else {
        document.addEventListener('DOMContentLoaded', register, {
            once: true,
            passive: true,
        });
    }
})(function() {
    if (customElements.get('base-gdpr-protected') === undefined) {
        const template = document.createElement('template');
        template.innerHTML = `
        <style>
        :host {
          display: block;
          text-align: center;
          padding: 1em;
          background: whitesmoke;
        }
        section {
          display: none;
        }
        </style>
        <section><slot></slot></section>
        <slot name="consentText">
            <p>
                Do you want to allow this component?
            </p>
        </slot>
        <slot name="buttons">
            <div>
                <button type="button" name="accept-once">
                    Show content
                </button>
            </div>
        </slot>
        `;

        customElements.define('base-gdpr-protected', class extends HTMLElement {

            constructor() {
                super();
                this.attachShadow({mode: "open"}).appendChild(template.content.cloneNode(true));
                this.consented = false;
            }

            connectedCallback() {
                this.shadowRoot.querySelector('slot[name="buttons"]').addEventListener('click', this.consentCallback.bind(this));
            }

            consentGiven() {
                if (this.consented) {
                    return;
                }
                this.consented = true;
                const protectedContent = this.querySelector('script[type="text/x-gdpr-protected-content"]');
                const markup = protectedContent.innerText.replace(/(\<\/?)protected\-script([\>\s])/g, '$1script$2');
                const tmp = document.createElement('div');
                tmp.innerHTML = markup;
                const newNodes = [];
                Array.from(tmp.childNodes).forEach(node => {
                    this.parentElement.insertBefore(node, this);
                    newNodes.push(node);
                });
                this.dispatchEvent(new CustomEvent('gdprprotected.insertedmarkup', {
                    detail: {
                        parent: this.parentNode,
                        nodes: newNodes,
                    },
                    bubbles: true,
                }));

                this.parentElement.removeChild(this);
            }

            consentCallback(event) {
                this.consentGiven();
                window.dispatchEvent(new CustomEvent('gdprprotected.consentgiven', {
                    detail: {
                        key: this.getAttribute('gdpr-key'),
                        target: event.target
                    }
                }));
            }
        });
    }
});

